import { Modal } from '@nextui-org/react'
import React, { useEffect, useState } from 'react'
import { QueryClientProvider, useQueryClient } from 'react-query'
import { useSelector } from 'react-redux'

import { AnimatePresence } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { Redirect, Route, Switch, useLocation } from 'react-router-dom'
import HelmetComponent from '../../Component/Helmet'
import j2bdLogo from '../../assets/images/j2bd.svg'
import holloLogo from '../../assets/images/loghollo.png'
import useGetLikes from '../../hooks/useGetLikes'
import useGetMatchingOffers from '../../hooks/useGetMatchingOffers'
import useWindowDimensions from '../../hooks/useWindowDimensions'
import {
  setAmplitudeUserId,
  setAmplitudeUserProperties,
} from '../../services/amplitude'
import { checkFeatureFlag } from '../../utils/featureFlag'
import Applications from './Applications/Applications'
import Jobs from './Jobs/Jobs'
import Profile from './Profile/ProfileForm/ProfileForm'
import SettingsDrawer from './SettingsDrawer/SettingsDrawer'
import * as s from './TalentPlatform.styles'
import BottomNavigation from './components/BottomNavigation/BottomNavigation'
import NavBar from './components/NavBar/NavBar'

function Footer() {
  return <div className="footer" />
}

const TalentPlatform = () => {
  const queryClient = useQueryClient()
  const location = useLocation()
  const talent = useSelector((state) => state.talent)
  const { t } = useTranslation(['common', 'talentArea'], {
    useSuspense: false,
  })
  const { width } = useWindowDimensions()
  const [isSettingsOpen, setIsSettingsOpen] = useState(false)
  const [isProfileOpen, setIsProfileOpen] = useState(false)
  useGetLikes()
  useGetMatchingOffers()

  // useEffect(() => {
  //   if (location?.state?.fromSoftApply) {
  //     toast('You can update your informations if you want')
  //   }
  // }, [location])

  useEffect(() => {
    setAmplitudeUserProperties({
      Type: 'candidate',
      CompanyName: talent?.company?.name,
      ResearchStatus: talent?.researchStatus,
      JobDomain: talent?.jobDomain,
      Experience: talent?.experience,
    })
  }, [talent])

  useEffect(() => {
    if (talent?.id) {
      setAmplitudeUserId(talent.id)
    }
  }, [talent.id])

  return (
    <s.TalentPlatformWrapper>
      <HelmetComponent
        faviconUrl={checkFeatureFlag ? j2bdLogo : holloLogo}
        name={checkFeatureFlag ? 'J2BD Partners' : 'Hollo'}
      />
      <NavBar setIsProfileFormOpen={setIsSettingsOpen} />
      <AnimatePresence exitBeforeEnter>
        <QueryClientProvider client={queryClient}>
          {/* <ReactQueryDevtools position="top-left" /> */}
          <Switch location={location} key={location.pathname}>
            <Route
              path="/app"
              exact
              render={() => <Redirect to="/app/jobs" />}
            />
            <Route path="/app/jobs">
              <Jobs />
            </Route>
            <Route path="/app/applications">
              <Applications />
            </Route>
            <Route path="/app/profile">
              <Profile />
            </Route>
            <Route path="/app/myApplications">
              <Applications />
            </Route>
            <Route path="*">
              <Jobs />
            </Route>
          </Switch>
        </QueryClientProvider>
      </AnimatePresence>
      <Modal
        closeButton
        blur
        aria-labelledby="modal-title"
        open={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
      >
        <SettingsDrawer closeDrawer={() => setIsSettingsOpen(false)} />
      </Modal>

      {width < 768 && <BottomNavigation />}
      {width > 768 && <Footer />}
    </s.TalentPlatformWrapper>
  )
}

export default TalentPlatform
